var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 10.5,
  width: 13,
  height: 9,
  rx: 1.1,
  fill: "#2e4057"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 21.2,
  y: 11.7,
  width: 10.6,
  height: 6.6,
  fill: "#cfe3ee"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 25.6,
  y: 19.5,
  width: 1.8,
  height: 2.6,
  fill: "#2e4057"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 22.8,
  y: 22.1,
  width: 7.4,
  height: 1.4,
  rx: 0.7,
  fill: "#2e4057"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 23.5,
  width: 24,
  height: 2.6,
  rx: 1.2,
  fill: "#c8925a"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 26.1,
  width: 2.2,
  height: 11.9,
  fill: "#8a6238"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 35.5,
  y: 26.1,
  width: 2.2,
  height: 11.9,
  fill: "#8a6238"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 15.5,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 5.4,
  y: 21.7,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 8.35,
  y: 23.6,
  width: 1.3,
  height: 2.4,
  fill: "#5c6870"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 6.3,
  y: 26,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 8.35,
  y: 27.1,
  width: 1.3,
  height: 11,
  fill: "#5c6870"
});

function SvgOffices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffices);
export default __webpack_public_path__ + "static/media/offices.e48121df05a2c4371978f9e263d1f78b.svg";
export { ForwardRef as ReactComponent };